import dayjs from 'hb-react/shared/utils/dayjs/dayjs';

const ucFirst = (string = '') =>
  string.charAt(0).toUpperCase() + string.slice(1);

export const getMonths = (locale) => {
  if (locale) {
    dayjs.locale(locale);
  }

  return dayjs.months().map(ucFirst);
};

export const date = (format = '') => dayjs().format(format);

export const dateFromString = (date) => dayjs(date);

export const getFormattedDateByLocale = (date, locale) => {
  const DAYJS_ERROR = 'Invalid Date';
  const dateFormating = isUsingEnTimeSystem(locale)
    ? 'MM/DD/YYYY'
    : 'DD/MM/YYYY';

  const formattedDate = dayjs(date).format(dateFormating);

  return formattedDate === DAYJS_ERROR ? date : formattedDate;
};

const isUsingEnTimeSystem = (locale = window.__HB_LOCALE__) =>
  ['en', 'en-GB'].indexOf(locale) !== -1;
